<template>
    <img class="logo-bienvenida" alt="pastel imagen" src="../assets/imagen-pasteleria.png">
</template>

<script>

export default {
  name: 'ImgBienvenida',
}
</script>

<style>
  .logo-bienvenida {
    border-radius: 15%;
    width: 800px;
    
  }
</style>>
